export const anneeIFData = [
  {value: 2019, label: '2019'},
  {value: 2018, label: '2018'},
  {value: 2017, label: '2017'},
  {value: 2016, label: '2016'},
  {value: 2015, label: '2015'},
];

export const logement_socialData = [
  {value: '1', label: 'Oui'},
  {value: '2', label: 'Non'},
];

export const destination_proprieteData = [
  {
    value: 'habitation_principale',
    label: 'Habitation principale',
  },
  {
    value: 'habitation_secondaire',
    label: 'Habitation secondaire',
  },
  {
    value: 'gratuit',
    label: 'Mise à disposition gratuite',
  },
  {
    value: 'location_meublee',
    label: 'Location meublée',
  },
  {
    value: 'location_non_meublee',
    label: 'Location non meublée',
  },
];

export const communes_fiscalesData = [
  {
    name: 'ANAA',
    arch: 'TUAM-G',
    2015: 5,
    2016: 5,
    2017: 5,
    2018: 5,
    2019: 5,
    TVLLP: 0,
    patente: 5,
    licence: 5,
    zoneTD: 3,
    zoneLicence: 2,
  },
  {
    name: 'ARUE',
    arch: 'IDV',
    2015: 50,
    2016: 50,
    2017: 50,
    2018: 50,
    2019: 50,
    TVLLP: 10,
    patente: 80,
    licence: 100,
    zoneTD: 1,
    zoneLicence: 1,
  },
  {
    name: 'ARUTUA',
    arch: 'TUAM-G',
    2015: 1,
    2016: 1,
    2017: 1,
    2018: 1,
    2019: 1,
    TVLLP: 0,
    patente: 50,
    licence: 100,
    zoneTD: 3,
    zoneLicence: 2,
  },
  {
    name: 'BORA-BORA',
    arch: 'ISLV',
    2015: 20,
    2016: 30,
    2017: 30,
    2018: 40,
    2019: 40,
    TVLLP: 10,
    patente: 80,
    licence: 100,
    zoneTD: 2,
    zoneLicence: 1,
  },
  {
    name: 'FAAA',
    arch: 'IDV',
    2015: 50,
    2016: 50,
    2017: 50,
    2018: 50,
    2019: 50,
    TVLLP: 10,
    patente: 80,
    licence: 100,
    zoneTD: 1,
    zoneLicence: 1,
  },
  {
    name: 'FAKARAVA',
    arch: 'TUAM-G',
    2015: 1,
    2016: 1,
    2017: 1,
    2018: 1,
    2019: 1,
    TVLLP: 0,
    patente: 3,
    licence: 10,
    zoneTD: 3,
    zoneLicence: 2,
  },
  {
    name: 'FANGATAU',
    arch: 'TUAM-G',
    2015: 1,
    2016: 1,
    2017: 1,
    2018: 1,
    2019: 1,
    TVLLP: 0,
    patente: 5,
    licence: 10,
    zoneTD: 3,
    zoneLicence: 2,
  },
  {
    name: 'FATU-HIVA',
    arch: 'MARQ',
    2015: 0,
    2016: 0,
    2017: 0,
    2018: 0,
    2019: 0,
    TVLLP: 0,
    patente: 50,
    licence: 50,
    zoneTD: 3,
    zoneLicence: 2,
  },
  {
    name: 'GAMBIER',
    arch: 'TUAM-G',
    2015: 25,
    2016: 25,
    2017: 25,
    2018: 50,
    2019: 50,
    TVLLP: 0,
    patente: 80,
    licence: 100,
    zoneTD: 3,
    zoneLicence: 2,
  },
  {
    name: 'HAO',
    arch: 'TUAM-G',
    2015: 0,
    2016: 0,
    2017: 0,
    2018: 0,
    2019: 0,
    TVLLP: 0,
    patente: 60,
    licence: 60,
    zoneTD: 3,
    zoneLicence: 2,
  },
  {
    name: 'HIKUERU',
    arch: 'TUAM-G',
    2015: 50,
    2016: 50,
    2017: 50,
    2018: 50,
    2019: 50,
    TVLLP: 0,
    patente: 80,
    licence: 100,
    zoneTD: 3,
    zoneLicence: 2,
  },
  {
    name: 'HITIAA O TE RA',
    arch: 'IDV',
    2015: 50,
    2016: 50,
    2017: 50,
    2018: 50,
    2019: 50,
    TVLLP: 10,
    patente: 80,
    licence: 100,
    zoneTD: 2,
    zoneLicence: 1,
  },
  {
    name: 'HIVA OA',
    arch: 'MARQ',
    2015: 0,
    2016: 0,
    2017: 0,
    2018: 0,
    2019: 0,
    TVLLP: 0,
    patente: 50,
    licence: 50,
    zoneTD: 3,
    zoneLicence: 1,
  },
  {
    name: 'HUAHINE',
    arch: 'ISLV',
    2015: 25,
    2016: 25,
    2017: 50,
    2018: 50,
    2019: 50,
    TVLLP: 10,
    patente: 80,
    licence: 100,
    zoneTD: 2,
    zoneLicence: 1,
  },
  {
    name: 'MAHINA',
    arch: 'IDV',
    2015: 50,
    2016: 50,
    2017: 50,
    2018: 50,
    2019: 50,
    TVLLP: 10,
    patente: 80,
    licence: 100,
    zoneTD: 1,
    zoneLicence: 1,
  },
  {
    name: 'MAKEMO',
    arch: 'TUAM-G',
    2015: 0,
    2016: 0,
    2017: 0,
    2018: 0,
    2019: 0,
    TVLLP: 0,
    patente: 40,
    licence: 50,
    zoneTD: 3,
    zoneLicence: 2,
  },
  {
    name: 'MANIHI',
    arch: 'TUAM-G',
    2015: 15,
    2016: 15,
    2017: 15,
    2018: 15,
    2019: 15,
    TVLLP: 0,
    patente: 25,
    licence: 30,
    zoneTD: 3,
    zoneLicence: 2,
  },
  {
    name: 'MAUPITI',
    arch: 'ISLV',
    2015: 0,
    2016: 0,
    2017: 0,
    2018: 0,
    2019: 0,
    TVLLP: 0,
    patente: 50,
    licence: 50,
    zoneTD: 2,
    zoneLicence: 2,
  },
  {
    name: 'MOOREA-MAIAO',
    arch: 'IDV',
    2015: 50,
    2016: 50,
    2017: 50,
    2018: 50,
    2019: 50,
    TVLLP: 8,
    patente: 80,
    licence: 100,
    zoneTD: 2,
    zoneLicence: 1,
  },
  {
    name: 'NAPUKA',
    arch: 'TUAM-G',
    2015: 0,
    2016: 0,
    2017: 0,
    2018: 0,
    2019: 0,
    TVLLP: 0,
    patente: 0,
    licence: 0,
    zoneTD: 3,
    zoneLicence: 2,
  },
  {
    name: 'NUKU-HIVA',
    arch: 'MARQ',
    2015: 0,
    2016: 0,
    2017: 0,
    2018: 0,
    2019: 0,
    TVLLP: 1,
    patente: 50,
    licence: 50,
    zoneTD: 3,
    zoneLicence: 1,
  },
  {
    name: 'NUKUTAVAKE',
    arch: 'TUAM-G',
    2015: 15,
    2016: 15,
    2017: 15,
    2018: 15,
    2019: 15,
    TVLLP: 0,
    patente: 5,
    licence: 10,
    zoneTD: 3,
    zoneLicence: 2,
  },
  {
    name: 'PAEA',
    arch: 'IDV',
    2015: 50,
    2016: 50,
    2017: 50,
    2018: 50,
    2019: 50,
    TVLLP: 10,
    patente: 80,
    licence: 95,
    zoneTD: 2,
    zoneLicence: 1,
  },
  {
    name: 'PAPARA',
    arch: 'IDV',
    2015: 50,
    2016: 50,
    2017: 50,
    2018: 50,
    2019: 50,
    TVLLP: 10,
    patente: 80,
    licence: 100,
    zoneTD: 2,
    zoneLicence: 1,
  },
  {
    name: 'PAPEETE',
    arch: 'IDV',
    2015: 50,
    2016: 50,
    2017: 50,
    2018: 50,
    2019: 50,
    TVLLP: 10,
    patente: 80,
    licence: 100,
    zoneTD: 1,
    zoneLicence: 1,
  },
  {
    name: 'PIRAE',
    arch: 'IDV',
    2015: 50,
    2016: 50,
    2017: 50,
    2018: 50,
    2019: 50,
    TVLLP: 10,
    patente: 80,
    licence: 100,
    zoneTD: 1,
    zoneLicence: 1,
  },
  {
    name: 'PUKAPUKA',
    arch: 'TUAM-G',
    2015: 5,
    2016: 5,
    2017: 5,
    2018: 5,
    2019: 5,
    TVLLP: 0,
    patente: 5,
    licence: 10,
    zoneTD: 3,
    zoneLicence: 2,
  },
  {
    name: 'PUNAAUIA',
    arch: 'IDV',
    2015: 50,
    2016: 50,
    2017: 50,
    2018: 50,
    2019: 50,
    TVLLP: 10,
    patente: 80,
    licence: 100,
    zoneTD: 1,
    zoneLicence: 1,
  },
  {
    name: 'RAIVAVAE',
    arch: 'AUST',
    2015: 0,
    2016: 0,
    2017: 0,
    2018: 0,
    2019: 0,
    TVLLP: 0,
    patente: 80,
    licence: 100,
    zoneTD: 3,
    zoneLicence: 2,
  },
  {
    name: 'RANGIROA',
    arch: 'TUAM-G',
    2015: 10,
    2016: 10,
    2017: 10,
    2018: 10,
    2019: 10,
    TVLLP: 0,
    patente: 40,
    licence: 100,
    zoneTD: 3,
    zoneLicence: 1,
  },
  {
    name: 'RAPA',
    arch: 'AUST',
    2015: 0,
    2016: 0,
    2017: 0,
    2018: 0,
    2019: 0,
    TVLLP: 0,
    patente: 0,
    licence: 0,
    zoneTD: 3,
    zoneLicence: 2,
  },
  {
    name: 'REAO',
    arch: 'TUAM-G',
    2015: 3,
    2016: 3,
    2017: 3,
    2018: 3,
    2019: 3,
    TVLLP: 0,
    patente: 30,
    licence: 80,
    zoneTD: 3,
    zoneLicence: 2,
  },
  {
    name: 'RIMATARA',
    arch: 'AUST',
    2015: 0,
    2016: 0,
    2017: 0,
    2018: 0,
    2019: 0,
    TVLLP: 0,
    patente: 80,
    licence: 100,
    zoneTD: 3,
    zoneLicence: 2,
  },
  {
    name: 'RURUTU',
    arch: 'AUST',
    2015: 10,
    2016: 10,
    2017: 10,
    2018: 10,
    2019: 10,
    TVLLP: 10,
    patente: 80,
    licence: 100,
    zoneTD: 3,
    zoneLicence: 2,
  },
  {
    name: 'TAHAA',
    arch: 'ISLV',
    2015: 50,
    2016: 50,
    2017: 50,
    2018: 50,
    2019: 50,
    TVLLP: 10,
    patente: 80,
    licence: 100,
    zoneTD: 2,
    zoneLicence: 1,
  },
  {
    name: 'TAHUATA',
    arch: 'MARQ',
    2015: 0,
    2016: 0,
    2017: 0,
    2018: 0,
    2019: 0,
    TVLLP: 0,
    patente: 0,
    licence: 0,
    zoneTD: 3,
    zoneLicence: 2,
  },
  {
    name: 'TAIARAPU-EST',
    arch: 'IDV',
    2015: 15,
    2016: 15,
    2017: 20,
    2018: 25,
    2019: 25,
    TVLLP: 3.5,
    patente: 80,
    licence: 100,
    zoneTD: 2,
    zoneLicence: 1,
  },
  {
    name: 'TAIARAPU-OUEST',
    arch: 'IDV',
    2015: 50,
    2016: 50,
    2017: 50,
    2018: 50,
    2019: 50,
    TVLLP: 0,
    patente: 80,
    licence: 100,
    zoneTD: 2,
    zoneLicence: 1,
  },
  {
    name: 'TAKAROA',
    arch: 'TUAM-G',
    2015: 10,
    2016: 10,
    2017: 10,
    2018: 10,
    2019: 10,
    TVLLP: 0,
    patente: 10,
    licence: 30,
    zoneTD: 3,
    zoneLicence: 2,
  },
  {
    name: 'TAPUTAPUATEA',
    arch: 'ISLV',
    2015: 50,
    2016: 50,
    2017: 50,
    2018: 50,
    2019: 50,
    TVLLP: 10,
    patente: 80,
    licence: 100,
    zoneTD: 2,
    zoneLicence: 1,
  },
  {
    name: 'TATAKOTO',
    arch: 'TUAM-G',
    2015: 10,
    2016: 10,
    2017: 10,
    2018: 10,
    2019: 10,
    TVLLP: 0,
    patente: 30,
    licence: 100,
    zoneTD: 3,
    zoneLicence: 2,
  },
  {
    name: 'TEVA I UTA',
    arch: 'IDV',
    2015: 50,
    2016: 50,
    2017: 50,
    2018: 50,
    2019: 50,
    TVLLP: 10,
    patente: 80,
    licence: 100,
    zoneTD: 2,
    zoneLicence: 1,
  },
  {
    name: 'TUBUAI',
    arch: 'AUST',
    2015: 10,
    2016: 10,
    2017: 10,
    2018: 10,
    2019: 10,
    TVLLP: 10,
    patente: 80,
    licence: 100,
    zoneTD: 3,
    zoneLicence: 2,
  },
  {
    name: 'TUMARAA',
    arch: 'ISLV',
    2015: 50,
    2016: 50,
    2017: 50,
    2018: 50,
    2019: 50,
    TVLLP: 10,
    patente: 40,
    licence: 50,
    zoneTD: 2,
    zoneLicence: 1,
  },
  {
    name: 'TUREIA',
    arch: 'TUAM-G',
    2015: 5,
    2016: 5,
    2017: 5,
    2018: 30,
    2019: 30,
    TVLLP: 0,
    patente: 30,
    licence: 60,
    zoneTD: 3,
    zoneLicence: 2,
  },
  {
    name: 'UA HUKA',
    arch: 'MARQ',
    2015: 0,
    2016: 0,
    2017: 0,
    2018: 0,
    2019: 0,
    TVLLP: 0,
    patente: 0,
    licence: 0,
    zoneTD: 3,
    zoneLicence: 2,
  },
  {
    name: 'UA-POU',
    arch: 'MARQ',
    2015: 0,
    2016: 0,
    2017: 0,
    2018: 0,
    2019: 0,
    TVLLP: 0,
    patente: 40,
    licence: 50,
    zoneTD: 3,
    zoneLicence: 2,
  },
  {
    name: 'UTUROA',
    arch: 'ISLV',
    2015: 50,
    2016: 50,
    2017: 50,
    2018: 50,
    2019: 50,
    TVLLP: 10,
    patente: 80,
    licence: 100,
    zoneTD: 2,
    zoneLicence: 1,
  },
];

export const communes_fiscalesDataNames = communes_fiscalesData.map((data) => ({
  label: data.name,
  value: data.name,
}));

export const taux_interets_archipel = [
  {
    id: 1,
    name: 'IDV',
    taux: 4,
  },
  {
    id: 2,
    name: 'ISLV',
    taux: 3,
  },
  {
    id: 3,
    name: 'MARQ',
    taux: 2,
  },
  {
    id: 4,
    name: 'AUST',
    taux: 2,
  },
  {
    id: 5,
    name: 'TUAM-G',
    taux: 2,
  },
];

export const taux_ifData = {
  2015: 10,
  2016: 10,
  2017: 10,
  2018: 10,
  2019: 10,
};

export const tauxInteretData = {
  2015: 4,
  2016: 4,
  2017: 4,
  2018: 4,
  2019: 4,
};

export const taux_premier_abatementData = {
  2015: 25,
  2016: 25,
  2017: 25,
  2018: 25,
  2019: 25,
};

export const taux_deuxieme_abatement_meubleData = {
  2015: 30,
  2016: 30,
  2017: 30,
  2018: 30,
  2019: 30,
};

export const taux_deuxieme_abatement_non_meubleData = {
  2015: 25,
  2016: 25,
  2017: 25,
  2018: 25,
  2019: 25,
};
